<div class="dl-panzoom__knop dl-panzoom__uitzoomen"
     [title]="weergaveInstellingen.beginnersmodusAan() ? '' : ('PANZOOM_ZOOMUIT' | translate)"
     dlBeginnersuitleg="panzoom_zoomuit"
     (pointerdown)="startZoomen(-1)">
    <span class="icon fa-solid fa-minus"></span>
</div>
<div class="dl-panzoom__knop dl-panzoom__inzoomen"
     [title]="weergaveInstellingen.beginnersmodusAan() ? '' : ('PANZOOM_ZOOMIN' | translate)"
     dlBeginnersuitleg="panzoom_zoomin"
     (pointerdown)="startZoomen(1)">
    <span class="icon fa-solid fa-plus"></span>
</div>
<div class="dl-panzoom__knop dl-panzoom__reset"
     [title]="weergaveInstellingen.beginnersmodusAan() ? '' : ('PANZOOM_RESET' | translate)"
     dlBeginnersuitleg="panzoom_reset"
     (pointerdown)="reset()">
    <span class="icon fa-solid fa-up-right-and-down-left-from-center"></span>
</div>
<div class="dl-panzoom__slider" #slider (pointerdown)="klikSlider($event)">
    <div class="dl-panzoom__spoor"></div>
    <div class="dl-panzoom__handle"
         [class.dl-panzoom__handle--actief]="sleept()"
         [style.left.px]="handleLinks()"
         [title]="weergaveInstellingen.beginnersmodusAan() ? '' : ('PANZOOM_ZOOM' | translate)"
         dlBeginnersuitleg="panzoom_slider"
         (pointerdown)="startSlepen($event)"
         (pointermove)="sleep($event)"
         (pointerup)="stopSlepen($event)"
         (pointercancel)="stopSlepen($event)"
         #handle>
        <div class="dl-panzoom__handle-streep"></div>
    </div>
    <div class="dl-panzoom__nulmarkering"></div>
</div>
